function parseDataURL(dataURL) {
  // Split DataURL into header and data parts
  const [header, data] = dataURL.split(',');

  // Extract MIME type from the header (e.g., "image/png")
  const mimeType = header.match(/:(.*?);/)[1];

  return { mimeType, data };
}
function decodeBase64ToBinary(base64Data) {
  // Decode Base64 string to UTF-8 string
  const decodedString = atob(base64Data);

  // Convert UTF-8 string to Uint8Array (binary data)
  const binaryData = new Uint8Array(decodedString.length);
  for (let i = 0; i < decodedString.length; i++) {
    binaryData[i] = decodedString.charCodeAt(i);
  }

  return binaryData;
}
function createBlob(binaryData, mimeType) {
  return new Blob([binaryData], { type: mimeType });
}
function blobToFile(blob, fileName) {
  // Extract MIME type from the blob (or default to "application/octet-stream")
  const mimeType = blob.type || "application/octet-stream";

  // Create File object with name, type, and last modified date
  return new File([blob], fileName, {
    type: mimeType,
    lastModified: Date.now() // Set last modified to current time
  });
}
export default function dataURLToFile(dataURL, fileName): File {
  try {
    // Step 1: Parse DataURL
    const { mimeType, data } = parseDataURL(dataURL);

    // Step 2: Decode Base64 to binary
    const binaryData = decodeBase64ToBinary(data);

    // Step 3: Create Blob
    const blob = createBlob(binaryData, mimeType);

    // Step 4: Convert Blob to File
    return blobToFile(blob, fileName);
  } catch (error) {
    console.error('Failed to convert DataURL to File:', error);
    return null;
  }
}
